module.exports = __webpack_public_path__ + "media/happy-birthday-155461.d1b5dc50.mp3";